export const JIRA_SOFTWARE = 'jira-software';
export const IFRAME_FLOW = 'persistent-upgrade';
export const GROWTH_FEATURE = 'persistentUpgrade';
export const PACKAGE_NAME = 'persistentUpgrade';
export const ANALYTIC_SOURCE = 'persistentUpgradeMenu';
export const CLICKED_EVENT_NAME = 'persistentUpgradeMenu clicked';
export const VIEWED_EVENT_NAME = 'persistentUpgradeMenu viewed';
